import { useSelector, TypedUseSelectorHook } from "react-redux";
import { TRootState } from "../../redux/reducers";

export const useTypedSelector: TypedUseSelectorHook<TRootState> = useSelector;
